import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PerfilesPop } from '@pages/fabrica-credito/interfaces/perfil';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Response } from '../../../shared/interfaces/response/response';


const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  
  private _url = environment.apiBaseUrl + 'api/perfil/';

  constructor(private _http: HttpClient) {}

  read(): Observable<Response> {
    return this._http.get<Response>(this._url);
  }

  create(model: PerfilesPop): Observable<Response> {
    let url: string = this._url + 'Create' ;
    return this._http.post<Response>(url, model, httpOption);
  }
  update(model: PerfilesPop): Observable<Response> {
    let url: string = this._url + 'Update' ;
    return this._http.put<Response>(url, model, httpOption);
  }

  delete(model: PerfilesPop): Observable<Response> {
    let url: string = this._url + 'Delete' ;
    return this._http.request<Response>('delete', url, {
      body: model,
    });
  }
}
